import { breakpointsTailwind, useBreakpoints } from "@vueuse/core"
import { type RouteLocationRaw } from "vue-router"

export default defineNuxtPlugin(async () => {
	const app = useNuxtApp()
	const i18nRedirected = useCookie<typeof app.$i18n.defaultLocale>("i18n_redirected", {
		default: () => app.$i18n.defaultLocale
	})

	await app.$i18n.setLocale(i18nRedirected.value)

	return {
		provide: {
			breakpoints: useBreakpoints(breakpointsTailwind),
			routeUrl: useRouteUrl(),
			stringUtil: useStringUtil(),
			validator: useValidator(),
			toastErrors: useToastErrors,
			copyToClipboard: useCopyToClipboard,
			backWithFallback: (to: RouteLocationRaw) => {
				if (history.state.position > 1 && history.state.back?.startsWith("/")) {
					app.$router.back()
				} else {
					app.$router.replace(to)
				}
			}
		}
	}
})
